import { createContext, useContext, useEffect, useState, useCallback } from "react";
import en from "@/i18n/en";
import es from "@/i18n/es";
import fr from "@/i18n/fr";
import de from "@/i18n/de";
import it from "@/i18n/it";
import pt from "@/i18n/pt";
import ru from "@/i18n/ru";
import he from "@/i18n/he";
import EXTRA from "@/i18n/services";
import MULTI from "@/i18n/multi";
import X2 from "@/i18n/extra2";
import X3 from "@/i18n/extra3";
import X4 from "@/i18n/extra4";
import OWNER from "@/i18n/owner";
import CLEANING from "@/i18n/cleaning";
import CLEANING2 from "@/i18n/cleaning2";
import RATE from "@/i18n/rating";
import X5 from "@/i18n/extra5";
import DESIGN from "@/i18n/design";

const BASE = { en, es, fr, de, it, pt, ru, he };
const DICTS = Object.fromEntries(Object.entries(BASE).map(([k, v]) => [k, { ...v, ...EXTRA[k], ...MULTI[k], ...X2[k], ...X3[k], ...X4[k], ...OWNER[k], ...CLEANING[k], ...CLEANING2[k], ...RATE[k], ...X5[k], ...DESIGN[k] }]));
const EN = DICTS.en;
export const LANGS = [
  { code: "en", name: "English" }, { code: "es", name: "Español" }, { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" }, { code: "it", name: "Italiano" }, { code: "pt", name: "Português" },
  { code: "ru", name: "Русский" }, { code: "he", name: "עברית" },
];

const Ctx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nf_lang") || "en");
  useEffect(() => {
    localStorage.setItem("nf_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "he" ? "rtl" : "ltr";
  }, [lang]);
  const t = useCallback((k, vars) => {
    let s = DICTS[lang]?.[k] ?? EN[k] ?? k;
    if (vars) Object.entries(vars).forEach(([a, b]) => { s = s.replace(`{${a}}`, b); });
    return s;
  }, [lang]);
  return <Ctx.Provider value={{ lang, setLang, t }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
